import React from "react";
import { AxiosResponse } from "axios";
import Message from "./components/Message";

import { IMessage, IAnswerRequest, IMessageResponse } from "app/api/types";

import Loader from "app/components/Loader";

import "./styles.scss";
import { Link } from "react-router-dom";

interface IProps {
  messageList: IMessage[];
  page: number;
  limit: number;
  count: number;
  isLoading: boolean;
  getMessages: (page: number) => Promise<IMessageResponse>;
  addAnswer: (data: IAnswerRequest) => Promise<AxiosResponse>;
  delMessage: (id: number) => Promise<AxiosResponse>;
}

interface IState {
  isSuccessActive: boolean;
  isSubmit: boolean;
  error: string;
}

class MessageList extends React.Component<IProps, IState> {
  state = {
    isSuccessActive: false,
    isSubmit: false,
    error: ""
  };

  addAnswer = (data: IAnswerRequest) => {
    this.props
      .addAnswer(data)
      .then(() => {
        this.setState({ error: "" });
        this.props.getMessages(Number(this.props.page));
      })
      .catch(err => this.setState({ error: err[0].msg }));
  };

  delMessage = (id: number) => {
    this.props
      .delMessage(id)
      .then(() => this.props.getMessages(Number(this.props.page)));
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  renderMessages = () => {
    if (this.props.messageList.length === 0) return <p>Сообщений нет</p>;

    return this.props.messageList.map(
      message =>
        message && (
          <Message
            message={message}
            onSubmit={this.addAnswer}
            onDelete={this.delMessage}
            key={message.id}
          />
        )
    );
  };

  renderPagination = () => {
    const { count, limit, page } = this.props;

    let items = [];

    for (let i = 0; i < Math.ceil(count / limit); i++) {
      items.push(
        <Link
          to={`/messages/page=${i + 1}`}
          className={`pagination__item ${
            page === i + 1 ? "pagination__item_active" : ""
          }`}
          key={i}
        >
          {i + 1}
        </Link>
      );
    }

    return items;
  };

  render() {
    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );

    return (
      <div className="user-group">
        <div className="records-user-group__header">
          <div className="records-header__group-label">
            {/* <p className="label__counter">
              вопросов: {this.props.messageList.length}
            </p> */}
          </div>
          <p className="label__error">{this.state.error}</p>
        </div>

        <div className="user-group__content">
          <div className="column">{this.renderMessages()}</div>
        </div>
        <div className="pagination-wrapper">{this.renderPagination()}</div>
      </div>
    );
  }
}

export default MessageList;
